
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { User as UserIcon } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import UserDropdownMenu from "./UserDropdownMenu";
import PremiumButton from "./PremiumButton";

const UserMenu = () => {
  const { user, isLoading } = useAuth();
  
  // Loading state
  if (isLoading) {
    return <div className="h-9 w-20 animate-pulse rounded-md bg-muted"></div>;
  }
  
  // If user is authenticated
  if (user) {
    return (
      <div className="flex items-center gap-2">
        <PremiumButton />
        <Link to="/profile">
          <Button variant="ghost" size="sm">
            <UserIcon className="h-4 w-4" />
            <span>My Account</span>
          </Button>
        </Link>
        <UserDropdownMenu />
      </div>
    );
  }
  
  // If user is not authenticated, show nothing
  return null;
};

export default UserMenu;
